module.exports = __webpack_public_path__ + "static/media/CTLA_2-356w.454bb434.jpg";